import React from 'react'
import { app, Block, use, config as _c } from 'xadmin'
import { C } from 'xadmin-ui'

const Dashboard = props => {
  const DashboardView = C('DashboardView')
  const DashboardNormalView = C('DashboardNormalView')

  const { user, user: { roles, rolesObjList } } = use('redux', state => ({ user: state.user }))
  const { settings } = use('settings')

  if (DashboardView && DashboardNormalView) {
    const sysDashboard = settings && settings.customPage &&
      (_c('isMobile') ? (settings?.mobilePage?.mobileDashboard) : settings.customPage.dashboard)
    let did = sysDashboard && sysDashboard.id

    if (user.dashboard && user.dashboard.did) {
      did = user.dashboard.did
    } else if (rolesObjList) {
      for (let i = 0; i < rolesObjList.length; i++) {
        const rolesObj = rolesObjList[i]
        if (rolesObj.dashboard && rolesObj.dashboard.did) {
          did = rolesObj.dashboard.did
          break
        }
      }
    }

    if (did != null || did != undefined) {
      return (
        <DashboardView params={{ id: did }} >
          <DashboardNormalView />
        </DashboardView>
      )
    }

  }
  return <Block name="dashboard.view" />
}

export default Dashboard
